import React, { useEffect } from 'react';

const Directions = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=5d499da089e61ca64970818b642c4f8e&autoload=false`;
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      const { kakao } = window;

      if (kakao && kakao.maps) {
        const mapContainer = document.getElementById('map');
        const mapOption = {
          center: new kakao.maps.LatLng(36.7894850443376, 127.107421226737),
          level: 3,
        };
        const map = new kakao.maps.Map(mapContainer, mapOption);

        // 기본 마커 생성
        const markerPosition = new kakao.maps.LatLng(36.7894850443376, 127.107421226737);
        const marker = new kakao.maps.Marker({
          position: markerPosition,
        });

        // 마커를 지도에 추가
        marker.setMap(map);
      } else {
        console.error('Kakao Maps API is not loaded');
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="directions-wrap" id="directions">
      <h2>Address</h2>
      <div className="directions-inner">
        <div className="directions-left-box">
          <span className="txa1">오시는 길</span>
          <span className="txa2">플레이션(PLASSION)</span>
        </div>
        <div className="directions-right-box">
          <span className="txa3">
            <span className="mobile-none-txa">주소. </span> 충청남도 아산시 배방읍 희망로46번길 45-7, 충남글로벌게임센터
            304호
          </span>
          <span className="txa4">
            <span className="mobile-none-txa">이메일. </span> plassion@naver.com
          </span>
          <span className="txa5">
            <span className="mobile-none-txa">FAX. </span> 0504-373-4873
          </span>
        </div>
      </div>
      <div className="map-right-wrap" id="map"></div>
    </div>
  );
};

export default Directions;
